import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import "./registerServiceWorker";
import "./quasar";
import "./validations";

import posthog from "posthog-js";

posthog.init(process.env.VUE_APP_POSTHOG_TOKEN || 'phc_sWzinwvbjKf2V8KibzBsRsgEFeNMXW7yVoRBBXWFSMFv', {
	api_host: process.env.VUE_APP_POSTHOG_HOST || 'https://metrics.bartradingx.com',
	defaults: '2026-01-30',
	person_profiles: 'always',
  });

Vue.config.productionTip = false;

if (typeof process.env.VUE_SENTRY_DSN !== 'undefined') {
	Sentry.init({
	  dsn: process.env.VUE_SENTRY_DSN,
	  integrations: [new Integrations.Vue({Vue, attachProps: true})],
	});
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
